import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { LUXURY_ESCAPES } from 'constants/brands'
import config from 'constants/config'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import { FormattedMessage, useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import useProductLabels from 'hooks/useProductLabels'
import TermsAndConditionsLink from '../TermsAndConditionsLink'

function ReserveForZeroPolicyModalContent() {
  const intl = useIntl()
  const { leFlashHotelProductLabel, flashHotelProductLabel } = useProductLabels()
  const hotelProductType = config.BRAND === LUXURY_ESCAPES
    ? leFlashHotelProductLabel
    : flashHotelProductLabel

  return (
    <Group gap={24} direction="vertical">
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'hI0nQDLzPiP3yr03mVXP',
            defaultMessage: 'Cancellation policy',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'zoLv1mrIEmAPZjEuVNCR',
            defaultMessage: 'You can cancel your reservation free of charge within 48 hours of submitting your reservation. After that, you will be automatically charged for the booking as per your selected payment plan. Please visit our terms & conditions below to view refund policies.',
          })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'N-7179uLm6kGuAw5Bx1Z',
            defaultMessage: 'Eligibility',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage(
            {
              id: 'gX8DgtkV8jIYq6KKySNS',
              defaultMessage: 'Currently available for {productType}, LPP and LPC deals.',
            },
            { productType: hotelProductType || config.productTypeLabelMap[OFFER_TYPE_HOTEL] },
          )}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'v4mUu4T_jaFOfKJ_h6sS',
            defaultMessage: 'Maximum open reservations',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'iEPalUnyI3cVyS8rrGMd',
            defaultMessage: 'You can only make 2 reservations at one time.',
          })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'ybk-_1idovAl0O6r1ZC9',
            defaultMessage: 'Reservation fee',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: '2o4VSAAxdt-xOpwPtXaF',
            defaultMessage: 'There is no fee for the 48 hour reservation. After that, any standard booking or service fees applicable to your booking will apply.',
          })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'LJ0zJGzwjgXIvyJUklLB',
            defaultMessage: 'Failed payments',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'r-zVnOplJAUFuBJSIVET',
            defaultMessage: 'Failure to complete payment will result in the cancellation of your booking.',
          })}
        </BodyText>
      </Group>
      <BodyText variant="medium">
        <FormattedMessage
          id="sRY5vw1zEUX3utnSoRLS"
          defaultMessage="{brandName} T&C''s apply - see {termsLink}."
          
          values={{
            brandName: config.brandConfig.name,
            termsLink: <TermsAndConditionsLink />,
          }}
        />
      </BodyText>
    </Group>
  )
}

export default ReserveForZeroPolicyModalContent
